/* Luxe 2026: desktop-only hover video on product cards. Loads a card's video only when pointed at. */
(function () {
  if (window.__luxeCards) return; window.__luxeCards = true;
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  function setup(card) {
    var tpl = card.querySelector('template.lx-hover-video');
    if (!tpl) return;
    var src = tpl.content.querySelector('video');
    if (!src) return;
    var media = tpl.parentElement;
    var v = src.cloneNode(true);
    v.classList.add('lx-hover-vid'); v.muted = true; v.defaultMuted = true; v.playsInline = true; v.loop = true; v.preload = 'auto';
    v.setAttribute('aria-hidden', 'true'); v.setAttribute('tabindex', '-1');
    media.appendChild(v);
    function on() { media.classList.add('lx-hovering'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    function off() { media.classList.remove('lx-hovering'); v.pause(); }
    card.addEventListener('mouseenter', on); card.addEventListener('mouseleave', off);
    on();
  }
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('.card-wrapper');
    if (!card || card.__lxv) return;
    card.__lxv = true; setup(card);
  });
})();
